
<div class="progress-column">
  <div class="progress-container" *ngFor="let item of progresList">
    <span>Tiến trình #{{item.requestId}}: <br> 
      Đang xử lý: {{item.requestName}}</span>
    <div class="progress">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="width: 75%"></div>
    </div>
  </div>
</div>